import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ActivityFeed = ({ activities, onViewProvenance }) => {
  const getActivityIcon = (type) => {
    const iconMap = {
      'transfer': 'ArrowRightLeft',
      'retirement': 'Trash2',
      'issuance': 'Plus',
      'integrity_update': 'Shield',
      'claim_created': 'FileText',
      'verification': 'CheckCircle'
    };
    return iconMap?.[type] || 'Circle';
  };

  const getActivityColor = (type) => {
    const colorMap = {
      'transfer': 'text-primary bg-primary/10',
      'retirement': 'text-error bg-error/10',
      'issuance': 'text-success bg-success/10',
      'integrity_update': 'text-warning bg-warning/10',
      'claim_created': 'text-accent bg-accent/10',
      'verification': 'text-success bg-success/10'
    };
    return colorMap?.[type] || 'text-muted-foreground bg-muted/10';
  };

  const formatTimeAgo = (timestamp) => {
    const now = new Date();
    const diff = now - new Date(timestamp);
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);

    if (minutes < 60) return `${minutes}m ago`;
    if (hours < 24) return `${hours}h ago`;
    return `${days}d ago`;
  };

  return (
    <div className="bg-card border border-border rounded-lg">
      <div className="p-6 border-b border-border">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-card-foreground">Recent Activity</h3>
          <Button variant="ghost" size="sm" iconName="ExternalLink">
            View All
          </Button>
        </div>
      </div>
      <div className="p-6">
        <div className="space-y-4">
          {activities?.map((activity) => (
            <div key={activity?.id} className="flex items-start space-x-4">
              <div className={`p-2 rounded-lg ${getActivityColor(activity?.type)}`}>
                <Icon name={getActivityIcon(activity?.type)} size={16} />
              </div>
              
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <p className="text-sm font-medium text-card-foreground">
                      {activity?.title}
                    </p>
                    <p className="text-sm text-muted-foreground mt-1">
                      {activity?.description}
                    </p>
                    
                    {activity?.metadata && (
                      <div className="flex items-center space-x-4 mt-2 text-xs text-muted-foreground">
                        {activity?.metadata?.serialNumber && (
                          <span>Serial: {activity?.metadata?.serialNumber}</span>
                        )}
                        {activity?.metadata?.quantity && (
                          <span>Qty: {activity?.metadata?.quantity?.toLocaleString()} tCO2e</span>
                        )}
                        {activity?.metadata?.registry && (
                          <span>Registry: {activity?.metadata?.registry}</span>
                        )}
                      </div>
                    )}
                  </div>
                  
                  <div className="flex items-center space-x-2 ml-4">
                    <span className="text-xs text-muted-foreground whitespace-nowrap">
                      {formatTimeAgo(activity?.timestamp)}
                    </span>
                    {activity?.hasProvenance && (
                      <Button
                        variant="ghost"
                        size="sm"
                        iconName="GitBranch"
                        onClick={() => onViewProvenance(activity)}
                      >
                        Trace
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {activities?.length === 0 && (
          <div className="text-center py-8">
            <Icon name="Activity" size={48} className="text-muted-foreground mx-auto mb-4" />
            <p className="text-muted-foreground">No recent activity</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ActivityFeed;